import { combineReducers } from 'redux';
import userSilcer from './slices/UserSilcer';
import commonSlicer from './slices/commonSlicer';
import sseSlicer from './slices/sseSlice';
import TenantSlicer from './slices/TenantSlicer';

const RootReducer = combineReducers({
  users: userSilcer,
  common: commonSlicer,
  sse: sseSlicer,
  tenant: TenantSlicer,
});

export default RootReducer;
